import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@jbnl/shared-ui";
import { handleidingPaginas } from "./paginas";
import { MarkdownContent } from "./MarkdownContent";

/**
 * A stale or hand-typed slug falls back to the first page rather than a not-found - the same
 * `.catch()` reasoning `gekozen` carries in `router.tsx`: a link into an older version of the
 * handleiding should land on the manual, not on an error.
 */
export function Handleiding({
  slug,
  onKies,
}: {
  slug: string | undefined;
  onKies: (slug: string) => void;
}) {
  const huidige =
    handleidingPaginas.find((p) => p.slug === slug) ?? handleidingPaginas[0];

  return (
    <div className="grid gap-4 lg:grid-cols-[240px_1fr]">
      <nav aria-label="Handleiding" className="space-y-1">
        {handleidingPaginas.map((p) => (
          <button
            key={p.slug}
            type="button"
            onClick={() => onKies(p.slug)}
            aria-current={p.slug === huidige.slug ? "page" : undefined}
            className={cn(
              "block w-full rounded-md px-3 py-2 text-left text-sm hover:bg-accent",
              p.slug === huidige.slug && "bg-accent font-medium",
            )}
          >
            {p.titel}
          </button>
        ))}
      </nav>
      <Card>
        <CardContent className="py-6">
          <MarkdownContent markdown={huidige.markdown} />
        </CardContent>
      </Card>
    </div>
  );
}
